import React, { useState } from 'react';
import { getMaxTimeStamps } from 'gqlQueries/commonQueries';
import { useLazyQuery } from '@apollo/client';
import _ from 'lodash';
const errorMessage: string = 'Something went wrong!';
function useGetMaxTimeStamps() {
    const [data, setData] = useState<any>();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<null | string>(null);

    const [getMaxTimeStampsCall] = useLazyQuery(getMaxTimeStamps, {
        onCompleted: onFetchComplete,
        onError: onFetchError,
    });

    function onFetchComplete(payload: any) {
        try {
            setData(payload.getMaxTimeStamps);
        } catch (error: any) {
            console.error(error);
            setError(error);
        } finally {
            setLoading(false);
        }
    }

    function onFetchError(error: any = errorMessage) {
        setData(null);
        setLoading(false);
        setError(error);
    }

    return {
        data,
        loading,
        getMaxTimeStampsCall: (variables: any) => {
            setLoading(true);
            getMaxTimeStampsCall(variables);
        },
        error,
    };
}

export default useGetMaxTimeStamps;
